import { render, staticRenderFns } from "./GetTravel.vue?vue&type=template&id=67d937f4&scoped=true&"
import script from "./GetTravel.vue?vue&type=script&lang=js&"
export * from "./GetTravel.vue?vue&type=script&lang=js&"
import style0 from "./GetTravel.vue?vue&type=style&index=0&id=67d937f4&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d937f4",
  null
  
)

export default component.exports